import { InjectionToken } from '@angular/core';
import { TranslationObject } from '@ngx-translate/core';
import type { Loader } from '../../domain/module-loader.interface';

export const LOCALE_CONFIGURATION = new InjectionToken<Array<LocaleConfiguration>>('localeConfiguration');

export const LOCALE_DATA = new InjectionToken<LocaleDataWithTranslations>('localeData');

export enum LocaleLanguage {
  EN = 'en',
  FR = 'fr'
}

export enum Locale {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  en_CA = 'en-ca',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  fr_CA = 'fr-ca'
}

export interface CalendarStrings {
  readonly months: Array<string>;
  readonly weekdays: Array<string>;
  readonly shortMonths: Array<string>;
}

export class LocaleDetails {
  constructor(readonly locale: Locale,
              readonly groupSeparator: string,
              readonly decimalSeparator: string,
              readonly currencySymbol: string,
              readonly calendarStrings: CalendarStrings = { months: [], weekdays: [], shortMonths: [] }) {
  }
}

export interface LocaleDataWithTranslations {
  localeData: Array<string>;
  translations: TranslationObject;
}

export interface LocaleConfiguration extends Loader {
  readonly locale: Locale;
}
